<div class="overlay-spinner" *ngIf="LoaderStatus">
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-warning" style="width: 3rem; height: 3rem; " role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
<app-alert [Type]="AlertType" [View]="AlertStatus" [Message]="AlertMessage"></app-alert>
<div class="mx-5 pb-5">
  <app-pages-header></app-pages-header>
  <div class="bg-white mx-1 bottom-page-shadow rounded-bottom-extra pb-5">
    <div class="row ps-3 pt-4">
      <div class="col">
        <p> <span class="fw-bold">Integrasi</span> - Penghantaran e-Borang </p>
      </div>
    </div>
    <div class="row">
      <div class="col pt-3 mx-5 ">
        <p class="text-muted">Sila masukkan TIN atau Tarikh Muat Naik.</p>
      </div>
    </div>
    <div class="row pb-3">
      <div class="col-2 mx-5">
        <input type="number" class="form-control border-0 shadow" placeholder="TIN" [(ngModel)]="InputTaxRefNum" [ngModelOptions]="{standalone: true}">
      </div>
      <div class="col-6 offset-2">
        <div class="btn-toolbar d-flex justify-content-center">
          <div class="me-2">
            <button type="button" class="btn submit-button border-0 shadow rounded-2" role="button" (click)="Submit(InputTaxRefNum)">Hantar</button>
          </div>
          <div class="me-2">
            <button type="button" class="btn grey-default-button border-0 shadow rounded-2" role="button" (click)="Semula()">Semula</button>
          </div>
          <div class="me-2">
            <button type="button" class="btn grey-default-button border-0 shadow rounded-2" role="button" (click)="ViewAll()">Papar Semua</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row pb-3">
      <div class="mx-5 mt-3 col-2">
        <p class="text-center">ATAU</p>
      </div>
    </div>
    <div class="row">
      <div class="col-2 mx-5">
        <input type="text" id="startdate" class="form-control border-0 shadow" placeholder="Tarikh Daftar Mula" autocomplete="off">
      </div>
      <div class="col-2">
        <input type="text" id="enddate" class="form-control border-0 shadow" placeholder="Tarikh Daftar Hingga" autocomplete="off">
      </div>
    </div>
    <div class="bg-white mx-5" *ngIf="SearchStatus">
      <div class="pt-5">
        <p>Senarai e-DTS</p>
      </div>
      <div class="example-table-container">
        <table mat-table [dataSource]="dataSource" class="w-100">

          <ng-container matColumnDef="select">
            <!--<th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>TIN</th>-->
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>
              <mat-checkbox *ngIf="SelectAllStatus" (change)="$event ? toggleAllRows(dataSource) : null"
                            [checked]="selection.hasValue() || isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()">
              </mat-checkbox>
            </th>
            <td class="text-center" mat-cell *matCellDef="let row">
              <mat-checkbox *ngIf="row.signAccess" (click)="$event.stopPropagation()"
                            (change)="$event ? buttonToggle(row) : null"
                            [checked]="selection.isSelected(row)">
              </mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="taxpayername">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Pembayar Cukai</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.taxpName}}</td>
          </ng-container>
          <ng-container matColumnDef="tin">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>TIN</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.clientId}}</td>
          </ng-container>
          <ng-container matColumnDef="formtype">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Jenis Borang</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.jenisBorangTahun}}</td>
          </ng-container>
          <ng-container matColumnDef="registerdate">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tarikh Daftar</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.assignDate}}</td>
          </ng-container>
          <ng-container matColumnDef="staffname">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Nama Staff</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.staffName}}</td>
          </ng-container>
          <ng-container matColumnDef="agentname">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Nama Ejen</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.taname}}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let test;columns:displayedColumns"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-center" colspan="10">Tiada Rekod</td>
          </tr>
        </table>


        <div class=" d-flex justify-content-start align-items-start">
          <mat-paginator class="mat-evelation-z8 d-flex" (page)="paginatorEvent($event)" [pageIndex]="0" [pageSize]="10" [pageSizeOptions]="[10,15,20]" [length]="RecordCount">
          </mat-paginator>
          <button type="button" [ngClass]="SignButtonStatus ? '' : 'disabled' " class="btn submit-primary-button border-0 rounded-2 me-0 ms-auto mt-2" role="button" data-bs-toggle="modal" data-bs-target="#signModal">Hantar</button>
        </div>
      </div>
    </div>
  </div>
</div>



<!-- Sign Modal -->
<div class="modal fade" id="signModal" tabindex="-1" aria-labelledby="signModalLabel" aria-hidden="true">

  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content pb-5" style="background-color: #E8E8E8 !important;">
      <div class="modal-body">
        <div class="d-flex justify-content-end align-items-end pb-3">
          <button class="btn" #signCloseButton data-bs-dismiss="modal"><i class="bi bi-x-square-fill"></i></button>

        </div>
        <div class="row rounded-top-extra primary-colour shadow mx-3">
          <div class="col pt-2">
            <p>Sila masukkan No. Rujukan (No. Pengenalan) dan Kata Laluan</p>
          </div>
        </div>
        <div class="row rounded-bottom-extra shadow mx-3 default-content-bg-colour">
          <div class="col-12 p-4">
            <div class="form-floating mb-3">
              <input type="text" class="form-control border-0 shadow" id="floatingInput" placeholder="123456789012" value="{{SessionIDNo}}" disabled>
              <label for="floatingInput">No. Rujukan (No. Pengenalan)</label>
            </div>
          </div>
          <div class="col-12 p-4">
            <div class="form-floating mb-3">
              <input type="password" class="form-control border-0 shadow" id="floatingInput2" placeholder="************" [(ngModel)]="InputSignerPassword" [ngModelOptions]="{standalone: true}">
              <label for="floatingInput2">Kata Laluan</label>
            </div>
          </div>
          <div class="d-flex justify-content-center align-items-center p-5">
            <button type="button" style="width: 20rem;" class="btn submit-primary-button border-0 shadow rounded-4 bg-white" (click)="Sign(InputSignerPassword)">Tandatangan & Hantar</button>
            <button #openResultModal style="display:none;" data-bs-toggle="modal" data-bs-target="#resultModal">DISABLED</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Result Modal -->
<div class="modal fade" id="resultModal" tabindex="-1" aria-labelledby="resultModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content pb-5" style="background-color: #E8E8E8 !important;">
      <div class="modal-body">
        <div class="d-flex justify-content-end align-items-end pb-3">
          <button class="btn" #signCloseButton data-bs-dismiss="modal"><i class="bi bi-x-square-fill"></i></button>

        </div>
        <div>
          <table class="table">
            <thead>
              <tr>
                <th scope="col" class="primary-colour">Jenis Borang</th>
                <th scope="col" class="primary-colour">TIN</th>
                <th scope="col" class="primary-colour">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of ResultView">
                <td>{{row.formYear}}</td>
                <td>{{row.itRefNo}}</td>
                <td>{{row.statusSubmit}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
